































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Place } from '@/Dto';
import { Util } from '@/Util';
import Tags from './Tags.vue';
import StarRating from 'vue-star-rating'

@Component({
    components: {
      Tags, StarRating
  }
})
export default class PlacesList extends Vue {
  columns = 4;

  address(place: Place) {
    return Util.address(place);
  }

  get places() {
    return this.$store.getters.filteredPlaces;
  }

  link(place:Place) {
    return Util.getPlaceLink(place);
  }

  mounted() {
    this.$ga.page(Util.getTrackingUrl(this.$store.getters.view.toLowerCase(), this.$store.getters.filter.search));
  }
}
